import { GET_ACCESS_HOURS } from "./types";

const AccessHoursReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_ACCESS_HOURS:
            return {
                ...state,
                accessHours: payload,
                isFetching: false,
                wasFetched: true,
                error: false,
                message: ''
            }

        default:
            return state;
    }
}

export default AccessHoursReducer